module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Back-2430ff0323fb5bbab34bfe50572bd7c55ffa89b93ddb8f5ad2b5cf1956cbfd6e.svg";